/** Tipo de notificação no sino do portal (merge com NotificacaoPDC). */
export const FINES_PORTAL_NOTIFICATION_TYPE = 3;

export const FINES_PORTAL_ROUTE = '/portal/multas';
